import { useCallback, useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';

import { PlannerContext } from './PlannerContext';

/**
 * Hook that provides access to the FullCalendar API
 *
 * Note: calendarRef.current may be undefined on initial render, because refs are populated
 * after the component mounts and the ref callback runs. If you access calendarRef.current
 * directly in your component (e.g., during render), you may get undefined. To always get
 * the latest value, access calendarRef.current inside event handlers, effects, or callbacks
 * that run after mount. This ensures you are reading the most up-to-date ref value.
 *
 * @returns {Object} An object containing
 *   - ref: The ref to the FullCalendar instance
 */
export const useCalendarRef = () => {
  const calendarRef = useContextSelector(
    PlannerContext,
    useCallback((value) => value.calendarRef, []),
  );

  return useMemo(
    () => ({
      calendarRef,
    }),
    [calendarRef],
  );
};
